<div class="level-completed-container">
  <div>
    <img [draggable]="false" class="broedel" src="img/broedel.svg">
    <div class="completed-message small"><span [innerHtml]="gameFinishedTextAanvulling"></span></div>

    <img [draggable]="false"  class="completed-image-line" src="/img/popup/won-game-types/lijn.svg">
  </div>
  <img [draggable]="false" class="completed-image" [src]="gameIcon">
  <div class="completed-message"><span [innerHtml]="gameFinishedText"></span></div>
<div class="button-bar">
    <app-button-square [disabled]="!level.worksheet" class="downloadButton" (click)="printWerkblad(); audio.playSoundClick();">{{audio.text.games.print_worksheet}}</app-button-square>
    <app-button-next3 [disabled]="!downloaded" (clicked)="onClose(); audio.playSoundClick();">{{audio.text.global.continue}}</app-button-next3>
</div>
</div>
